export interface EventItem {
  id: string;
  title: string;
  date: string;
  month: string;
  location: string;
  description: string;
  status: "報名中" | "即將開始" | "已結束" | "名額有限";
  category: string;
  image: string;
  isOnline: boolean;
}

export interface NewsArticle {
  id: string;
  title: string;
  date: string;
  summary: string;
  category: string;
  image: string;
  isFeatured?: boolean;
}

export const allEvents: EventItem[] = [
  {
    id: "e1",
    title: "2025 AI 產業應用高峰論壇",
    date: "2025.06.15",
    month: "2025-06",
    location: "台北國際會議中心",
    description:
      "匯集產官學研代表，探討 AI 在製造、金融、醫療與教育領域的最新應用與趨勢。預計 800 人參與，包含專題演講、圓桌論壇與產業對接環節。",
    status: "報名中",
    category: "論壇",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20business%20conference%20stage%20with%20large%20LED%20screen%20displaying%20abstract%20AI%20and%20technology%20visualizations%2C%20modern%20auditorium%20interior%2C%20sleek%20dark%20seating%20rows%2C%20dramatic%20spotlight%20lighting%2C%20futuristic%20tech%20atmosphere%2C%20minimalist%20corporate%20design%2C%20silver%20and%20navy%20color%20tones&width=800&height=600&seq=taiaa-events-1&orientation=landscape",
    isOnline: false,
  },
  {
    id: "e2",
    title: "AI 驅動數位轉型工作坊",
    date: "2025.05.28",
    month: "2025-05",
    location: "線上 + 實體混合",
    description:
      "手把手帶領企業評估 AI 導入機會，從需求分析到技術選型，協助制定數位轉型策略。適合中小企業決策者與技術主管。",
    status: "即將開始",
    category: "工作坊",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20workshop%20classroom%20with%20participants%20using%20laptops%20and%20tablets%2C%20large%20interactive%20display%20showing%20data%20visualization%20and%20AI%20algorithms%2C%20clean%20bright%20interior%2C%20white%20and%20silver%20tones%2C%20professional%20training%20environment%2C%20minimalist%20design&width=800&height=600&seq=taiaa-events-2&orientation=landscape",
    isOnline: true,
  },
  {
    id: "e3",
    title: "AI 倫理與治理研討會",
    date: "2025.07.10",
    month: "2025-07",
    location: "台大法律學院",
    description:
      "聚焦 AI 倫理框架、法規趨勢與負責任 AI 應用，邀請國際專家與政策制定者共同對話。探討歐盟 AI 法案對台灣產業的影響。",
    status: "報名中",
    category: "研討會",
    image:
      "https://readdy.ai/api/search-image?query=Intellectual%20discussion%20panel%20with%20speakers%20at%20a%20round%20table%2C%20university%20lecture%20hall%20setting%2C%20projector%20screen%20showing%20AI%20ethics%20diagrams%2C%20academic%20atmosphere%2C%20serious%20professional%20tone%2C%20navy%20and%20white%20color%20scheme%2C%20modern%20university%20architecture&width=800&height=600&seq=taiaa-events-3&orientation=landscape",
    isOnline: false,
  },
  {
    id: "e4",
    title: "AI 人才培育教師研習營",
    date: "2025.08.05",
    month: "2025-08",
    location: "國立清華大學",
    description:
      "針對大專院校與高中職教師設計，提供 AI 素養課程設計、教學工具實作與評量方法分享。全程免費，提供研習時數認證。",
    status: "報名中",
    category: "工作坊",
    image:
      "https://readdy.ai/api/search-image?query=University%20campus%20modern%20building%20exterior%20with%20glass%20facade%20reflecting%20blue%20sky%2C%20green%20courtyard%2C%20students%20walking%2C%20academic%20atmosphere%2C%20clean%20architecture%2C%20bright%20daylight%2C%20professional%20educational%20environment%2C%20minimalist%20composition&width=800&height=600&seq=taiaa-events-4&orientation=landscape",
    isOnline: false,
  },
  {
    id: "e5",
    title: "TAIAA 年度會員大會暨年會",
    date: "2025.09.20",
    month: "2025-09",
    location: "台北文創大樓",
    description:
      "年度盛事，回顧協會年度成果、展望未來計畫，並進行理監事選舉。會員專屬活動，包含年度報告發表與會員交流晚宴。",
    status: "報名中",
    category: "年會",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20corporate%20gala%20dinner%20event%20in%20modern%20venue%20with%20warm%20ambient%20lighting%2C%20round%20tables%20with%20white%20tablecloths%2C%20large%20stage%20with%20presentation%20screen%2C%20professional%20networking%20atmosphere%2C%20sophisticated%20interior%20design%2C%20navy%20and%20gold%20accents&width=800&height=600&seq=taiaa-events-5&orientation=landscape",
    isOnline: false,
  },
  {
    id: "e6",
    title: "AI for Good 公益黑客松",
    date: "2025.10.18",
    month: "2025-10",
    location: "線上活動",
    description:
      "48 小時線上黑客松，邀請開發者與社會創新團隊運用 AI 技術解決社會議題。獲勝團隊將獲得協會輔導與資源媒合機會。",
    status: "報名中",
    category: "公益活動",
    image:
      "https://readdy.ai/api/search-image?query=Diverse%20team%20of%20young%20professionals%20collaborating%20around%20computers%20in%20modern%20co-working%20space%2C%20screens%20showing%20code%20and%20data%20visualizations%2C%20bright%20creative%20atmosphere%2C%20teamwork%20energy%2C%20contemporary%20office%20design%2C%20natural%20light%2C%20technology%20startup%20vibe&width=800&height=600&seq=taiaa-events-6&orientation=landscape",
    isOnline: true,
  },
  {
    id: "e7",
    title: "智慧製造 AI 應用專題講座",
    date: "2025.06.25",
    month: "2025-06",
    location: "工研院產業學院",
    description:
      "深入探討 AI 在製造業的品質檢測、預測性維護與流程優化應用，分享緯創、台積電等標竿案例。",
    status: "名額有限",
    category: "講座",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20smart%20factory%20interior%20with%20robotic%20arms%20and%20automated%20assembly%20lines%2C%20digital%20twin%20visualization%20on%20large%20screens%2C%20clean%20industrial%20environment%2C%20blue%20ambient%20lighting%2C%20advanced%20manufacturing%20technology%2C%20professional%20industrial%20photography&width=800&height=600&seq=taiaa-events-7&orientation=landscape",
    isOnline: false,
  },
  {
    id: "e8",
    title: "生成式 AI 實務應用工作坊",
    date: "2025.11.08",
    month: "2025-11",
    location: "線上課程",
    description:
      "從提示工程到企業級應用部署，帶領學員掌握生成式 AI 的實務技能。包含 Hands-on Lab 與實際案例分析。",
    status: "報名中",
    category: "工作坊",
    image:
      "https://readdy.ai/api/search-image?query=Person%20using%20laptop%20with%20holographic%20AI%20assistant%20interface%20floating%20above%20screen%2C%20futuristic%20workspace%2C%20clean%20minimalist%20desk%20setup%2C%20soft%20ambient%20lighting%2C%20technology%20concept%20photography%2C%20professional%20creative%20environment&width=800&height=600&seq=taiaa-events-8&orientation=landscape",
    isOnline: true,
  },
  // Past events for time filter
  {
    id: "e9",
    title: "AI 基礎認證課程",
    date: "2025.03.15",
    month: "2025-03",
    location: "線上課程",
    description:
      "為期六週的 AI 基礎線上課程，涵蓋機器學習原理、深度學習入門與實作專案。結業通過者獲得 TAIAA 認證證書。",
    status: "已結束",
    category: "講座",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20online%20learning%20platform%20interface%20displayed%20on%20laptop%20screen%2C%20digital%20certificate%20badge%20visible%2C%20modern%20educational%20technology%20concept%2C%20clean%20workspace%20with%20books%20and%20notebook%2C%20warm%20ambient%20lighting%2C%20minimalist%20aesthetic%2C%20navy%20and%20white%20tones&width=800&height=600&seq=taiaa-events-9&orientation=landscape",
    isOnline: true,
  },
  {
    id: "e10",
    title: "企業 AI 導入策略工作坊",
    date: "2025.02.20",
    month: "2025-02",
    location: "台北創新中心",
    description:
      "協助企業評估 AI 導入成熟度，制定策略藍圖。包含案例分享、工具實作與專家一對一諮詢環節。",
    status: "已結束",
    category: "工作坊",
    image:
      "https://readdy.ai/api/search-image?query=Business%20strategy%20workshop%20with%20whiteboard%20covered%20in%20diagrams%20and%20sticky%20notes%2C%20professionals%20collaborating%20around%20table%20with%20laptops%2C%20modern%20meeting%20room%20with%20glass%20walls%2C%20bright%20professional%20atmosphere%2C%20corporate%20training%20environment&width=800&height=600&seq=taiaa-events-10&orientation=landscape",
    isOnline: false,
  },
  {
    id: "e11",
    title: "AI 倫理法規趨勢講座",
    date: "2025.04.10",
    month: "2025-04",
    location: "線上活動",
    description:
      "邀請法律專家與政策研究者，解析全球 AI 法規發展趨勢，以及對台灣產業合規的具體影響與建議。",
    status: "已結束",
    category: "講座",
    image:
      "https://readdy.ai/api/search-image?query=Legal%20professional%20giving%20presentation%20about%20technology%20regulations%2C%20modern%20conference%20room%20with%20audience%2C%20large%20screen%20displaying%20law%20and%20AI%20governance%20diagrams%2C%20professional%20legal%20atmosphere%2C%20navy%20blue%20and%20white%20color%20scheme%2C%20formal%20corporate%20setting&width=800&height=600&seq=taiaa-events-11&orientation=landscape",
    isOnline: true,
  },
  {
    id: "e12",
    title: "TAIAA 冬季論壇",
    date: "2025.01.18",
    month: "2025-01",
    location: "台北大直典華",
    description:
      "首場大型公開論壇，聚焦 AI 在零售與電商領域的應用，吸引 500 位產業人士參與，開啟 TAIAA 年度活動序幕。",
    status: "已結束",
    category: "論壇",
    image:
      "https://readdy.ai/api/search-image?query=Large%20winter%20technology%20conference%20with%20audience%20in%20warm-lit%20auditorium%2C%20stage%20with%20professional%20lighting%2C%20modern%20event%20venue%20with%20high%20ceilings%2C%20elegant%20corporate%20atmosphere%2C%20silver%20and%20navy%20color%20tones%2C%20wide%20angle%20editorial%20photography&width=800&height=600&seq=taiaa-events-12&orientation=landscape",
    isOnline: false,
  },
];

export const allNews: NewsArticle[] = [
  {
    id: "n1",
    title: "TAIAA 發布 2025 台灣 AI 產業應用白皮書",
    date: "2025.05.10",
    summary:
      "本報告深入分析台灣各產業 AI 應用現況、挑戰與機會，為政策制定與企業決策提供參考依據。涵蓋製造、金融、醫療、零售與教育五大領域。",
    category: "出版品",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20white%20paper%20document%20on%20clean%20desk%20with%20laptop%20showing%20charts%20and%20data%20visualizations%2C%20elegant%20minimalist%20workspace%2C%20soft%20natural%20lighting%2C%20corporate%20report%20aesthetic%2C%20silver%20and%20white%20color%20tones%2C%20modern%20office%20setting&width=800&height=600&seq=taiaa-news-1&orientation=landscape",
    isFeatured: true,
  },
  {
    id: "n2",
    title: "協會與經濟部簽署 AI 產業合作備忘錄",
    date: "2025.04.22",
    summary:
      "TAIAA 與經濟部產業發展署簽署合作備忘錄，共同推動 AI 技術在製造業與中小企業的落地應用，預計輔導 100 家企業完成 AI 導入評估。",
    category: "合作公告",
    image:
      "https://readdy.ai/api/search-image?query=Two%20business%20professionals%20shaking%20hands%20in%20modern%20corporate%20meeting%20room%2C%20signing%20ceremony%20atmosphere%2C%20large%20window%20with%20city%20view%2C%20professional%20photography%2C%20elegant%20suits%2C%20navy%20and%20white%20interior%2C%20formal%20business%20setting&width=800&height=600&seq=taiaa-news-2&orientation=landscape",
  },
  {
    id: "n3",
    title: "第三屆 AI 人才培育計畫正式啟動",
    date: "2025.04.08",
    summary:
      "本年度計畫擴大至 20 所大專院校，預計培訓 500 位 AI 應用專才，並提供企業實習媒合機會。新增生成式 AI 與負責任 AI 課程模組。",
    category: "活動公告",
    image:
      "https://readdy.ai/api/search-image?query=University%20students%20in%20modern%20classroom%20with%20laptops%2C%20diverse%20group%20collaborating%20on%20AI%20project%2C%20large%20display%20showing%20neural%20network%20visualization%2C%20bright%20learning%20environment%2C%20educational%20technology%2C%20clean%20contemporary%20campus%20interior&width=800&height=600&seq=taiaa-news-3&orientation=landscape",
  },
  {
    id: "n4",
    title: "國際 AI 組織聯盟會議圓滿落幕",
    date: "2025.03.25",
    summary:
      "TAIAA 代表團赴新加坡參與亞太 AI 聯盟年度會議，與各國代表就 AI 治理與跨境合作達成多項共識，並簽署三項合作意向書。",
    category: "國際交流",
    image:
      "https://readdy.ai/api/search-image?query=International%20conference%20delegates%20in%20business%20attire%20standing%20together%20for%20group%20photo%2C%20modern%20convention%20center%20lobby%2C%20diverse%20professionals%20from%20Asia%20Pacific%20region%2C%20elegant%20corporate%20setting%2C%20bright%20professional%20lighting%2C%20multinational%20collaboration%20atmosphere&width=800&height=600&seq=taiaa-news-4&orientation=landscape",
  },
  {
    id: "n5",
    title: "TAIAA 向數位發展部提交 AI 治理政策建言書",
    date: "2025.03.12",
    summary:
      "協會彙整會員與專家意見，向政府提出十項政策建議，涵蓋 AI 沙盒機制、資料共享平台、人才簽證與產業輔導等面向。",
    category: "政策建言",
    image:
      "https://readdy.ai/api/search-image?query=Government%20policy%20document%20on%20desk%20with%20official%20stamps%20and%20seals%2C%20modern%20government%20office%20interior%2C%20digital%20policy%20reports%2C%20clean%20bureaucratic%20aesthetic%2C%20professional%20formal%20setting%2C%20navy%20and%20white%20color%20scheme%2C%20institutional%20authority%20atmosphere&width=800&height=600&seq=taiaa-news-5&orientation=landscape",
  },
  {
    id: "n6",
    title: "會員專屬：AI 金融應用線上講座開放報名",
    date: "2025.05.05",
    summary:
      "針對會員舉辦的專屬講座，邀請玉山銀行數位金融處處長分享 AI 在風險管理、客戶服務與投資決策中的實務應用經驗。",
    category: "活動公告",
    image:
      "https://readdy.ai/api/search-image?query=Online%20webinar%20interface%20on%20large%20screen%20with%20speaker%20presenting%20financial%20data%20charts%2C%20professional%20virtual%20meeting%20setup%2C%20modern%20office%20with%20multiple%20monitors%2C%20financial%20technology%20theme%2C%20clean%20corporate%20aesthetic%2C%20blue%20ambient%20lighting&width=800&height=600&seq=taiaa-news-6&orientation=landscape",
  },
  {
    id: "n7",
    title: "2025 Q1 台灣 AI 新創投資趨勢觀察",
    date: "2025.04.30",
    summary:
      "本季度台灣 AI 新創獲投總額達 4.2 億美元，生成式 AI 與醫療 AI 為兩大熱門領域。協會分析團隊深度解析投資趨勢與熱門賽道。",
    category: "產業觀察",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20financial%20data%20visualization%20with%20rising%20trend%20lines%20and%20investment%20charts%2C%20digital%20stock%20market%20interface%2C%20dark%20background%20with%20glowing%20data%20points%2C%20modern%20fintech%20aesthetic%2C%20professional%20analytics%20dashboard%2C%20navy%20blue%20and%20silver%20white%20accents&width=800&height=600&seq=taiaa-news-7&orientation=landscape",
  },
  {
    id: "n8",
    title: "協會新版官網正式上線，功能全面升級",
    date: "2025.05.22",
    summary:
      "全新官網提供更完整的活動資訊、會員服務與資源下載功能，優化行動裝置體驗，並新增線上活動報名系統。",
    category: "協會公告",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20responsive%20website%20displayed%20on%20multiple%20devices%2C%20laptop%20tablet%20and%20smartphone%20showing%20clean%20interface%20design%2C%20floating%20UI%20elements%2C%20professional%20web%20design%20concept%2C%20minimalist%20aesthetic%2C%20light%20background%2C%20technology%20showcase&width=800&height=600&seq=taiaa-news-8&orientation=landscape",
  },
];

export const eventCategories = [
  { key: "all", label: "全部活動" },
  { key: "論壇", label: "論壇" },
  { key: "工作坊", label: "工作坊" },
  { key: "研討會", label: "研討會" },
  { key: "講座", label: "講座" },
  { key: "年會", label: "年會" },
  { key: "公益活動", label: "公益活動" },
];

export const timeFilters = [
  { key: "upcoming", label: "即將舉行" },
  { key: "all", label: "全部活動" },
  { key: "報名中", label: "報名中" },
  { key: "已結束", label: "已結束" },
];

export const newsCategories = [
  { key: "all", label: "全部消息" },
  { key: "協會公告", label: "協會公告" },
  { key: "活動公告", label: "活動公告" },
  { key: "出版品", label: "出版品" },
  { key: "產業觀察", label: "產業觀察" },
  { key: "政策建言", label: "政策建言" },
  { key: "合作公告", label: "合作公告" },
  { key: "國際交流", label: "國際交流" },
];

export function getMonthLabel(monthKey: string): string {
  const map: Record<string, string> = {
    "2025-01": "2025 年 1 月",
    "2025-02": "2025 年 2 月",
    "2025-03": "2025 年 3 月",
    "2025-04": "2025 年 4 月",
    "2025-05": "2025 年 5 月",
    "2025-06": "2025 年 6 月",
    "2025-07": "2025 年 7 月",
    "2025-08": "2025 年 8 月",
    "2025-09": "2025 年 9 月",
    "2025-10": "2025 年 10 月",
    "2025-11": "2025 年 11 月",
  };
  return map[monthKey] || monthKey;
}

// Event type introductions for the intro section
export const eventTypeIntro = [
  {
    title: "產業論壇",
    icon: "ri-presentation-line",
    description: "匯集產官學研領袖，探討 AI 在各產業的最新趨勢、應用案例與發展策略。每年舉辦 2-3 場大型論壇，吸引 500+ 產業人士參與。",
  },
  {
    title: "專業工作坊",
    icon: "ri-tools-line",
    description: "Hands-on 實作導向的工作坊，從 AI 工具操作、提示工程到企業導入策略，協助參與者掌握可直接應用的技能。",
  },
  {
    title: "學術研討會",
    icon: "ri-book-open-line",
    description: "聚焦 AI 倫理、法規、治理與前瞻技術，邀請國內外學者與政策制定者共同對話，促進學術與實務交流。",
  },
  {
    title: "專題講座",
    icon: "ri-mic-line",
    description: "定期舉辦產業專題講座，邀請標竿企業與技術專家分享實務經驗，涵蓋金融、製造、醫療、零售等多元領域。",
  },
  {
    title: "年會與會員大會",
    icon: "ri-award-line",
    description: "年度最高規格活動，回顧協會年度成果、展望未來計畫，進行理監事選舉，並安排會員專屬交流晚宴。",
  },
  {
    title: "公益活動",
    icon: "ri-heart-3-line",
    description: "黑客松、AI for Good 專案等公益性質活動，邀請開發者與社會創新團隊運用 AI 技術解決社會議題，推動科技向善。",
  },
  {
    title: "課程培訓",
    icon: "ri-graduation-cap-line",
    description: "提供 AI 基礎認證課程、企業內訓與教師研習營，從理論到實作，培育各層級 AI 人才。結業可獲 TAIAA 認證。",
  },
];